import { defineMessages } from 'react-intl'

export const JobDetailsLocationMessages = defineMessages({
  title: {
    id: 'JobDetailsLocation.title',
    description: 'Title for Details/Location block on JobInfo page',
    defaultMessage: 'Location',
  },
  addressPlaceholder: {
    id: 'JobDetailsLocation.addressPlaceholder',
    description:
      'Placeholder for Address dropdown field in Details/Location block on JobInfo page',
    defaultMessage: 'Address',
  },
})
